import React from 'react';
import { useMediaQuery } from 'react-responsive';
import {
  trans,
  getPagePath,
  useSoyuzLocales,
  useSoyuzFlag
} from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import HeroContainer from '@components/HeroContainer';
import HeaderContainer from '@components/HeaderContainer';
import TrustPilotRating from '@components/TrustPilotRating';

import { addDataLayerGAEvent } from '../../../common/utils/DataLayerGAHandler';

import ArrangeCallHeroAddon from './ArrangeCallHeroAddon';

import './HeroLandlord.scss';

const MOBILE_MAX_WIDTH = 1024;

const HeroLandlord = () => {
  const removeCallMeBackModalFlag = useSoyuzFlag('removeCallMeBackModal');
  const currentLocale = useSoyuzLocales().current;

  const isDesiredLocale = locale => currentLocale === locale;

  const shouldRenderCallMeBackModal =
    isDesiredLocale('es') && removeCallMeBackModalFlag.isOff();

  const sendJoinTodayGaEvent = () => {
    addDataLayerGAEvent('Landlord', 'clickBtn', 'mainBtn');
  };

  const isMobile = useMediaQuery({
    query: `(max-width: ${MOBILE_MAX_WIDTH}px)`
  });

  return (
    <section>
      <HeroContainer>
        <div className="hero__header-wrapper">
          <HeaderContainer
            color={isMobile ? 'dark' : 'light'}
            tracking="ga-home-landlord"
            links={{ listYourProperty: null, tenantLandingPage: {} }}
          />
        </div>
        <div className="hero-landlord-wrapper">
          <div className="hero-landlord-container">
            <div className="hero-landlord__info">
              <div className="hero-landlord__info-content">
                <p
                  className="hero-landlord__info-heading"
                  dangerouslySetInnerHTML={{
                    __html: trans('lister.landing.page-header')
                  }}
                />
                <h1 className="hero-landlord__info-title">
                  {trans('lister.landing.page-title')}
                </h1>
                <p className="hero-landlord__info-subtitle">
                  {trans('lister.landing.page-subtitle')}
                </p>
                {shouldRenderCallMeBackModal ? (
                  <ArrangeCallHeroAddon />
                ) : (
                  <Button
                    data-test="landlord-cta"
                    className="hero-landlord__info-cta"
                    size="big"
                    color="complementary"
                    href={getPagePath('externals.landlord-signup')}
                    onClick={sendJoinTodayGaEvent}
                  >
                    {trans('lister.landing.page.topsection-CTA')}
                  </Button>
                )}
                <TrustPilotRating className="hero-landlord__info-rating" />
              </div>
            </div>
            <div className="hero-landlord__image" />
          </div>
        </div>
      </HeroContainer>
    </section>
  );
};

export default HeroLandlord;
